import React from "react";
import "../style/css/PublicConfirmationModal.css";

interface PublicConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
}

const PublicConfirmationModal: React.FC<PublicConfirmationModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = "Confirmar",
  cancelText = "Cancelar",
}) => {
  if (!isOpen) return null;

  return (
    <div className="public-modal-overlay" onClick={onClose}>
      <div className="public-modal-card" onClick={(e) => e.stopPropagation()}>
        <div className="public-modal-header">
          <div className="public-modal-status-icon">
            <i className="fas fa-exclamation-circle"></i>
          </div>
          <h3>{title}</h3>
        </div>

        <div className="public-modal-body">
          <p>{message}</p>
        </div>

        <div className="public-modal-footer">
          <button className="btn btn--secondary" onClick={onClose}>
            {cancelText}
          </button>
          <button className="btn btn--danger-action" onClick={onConfirm}>
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PublicConfirmationModal;
